<template>
	<b-card>
		<template #header>
			<b style="font-size: 18px">Продление срока годности товаров</b>
			<b-button @click="createForm" class="float-right fa fa-plus" variant="outline-primary"/>
		</template>
		<b-overlay :show="loading" rounded="sm">
			<b-tabs v-model="tab">
				<b-tab title="Списание">
					<b-table :items="list" :fields="fields1" striped hover show-empty empty-text="Информация не найдена !">
						<template slot="id" slot-scope="data">
							{{ paginate(data.index, payload.page, payload.limit) }}
						</template>
						<template slot="action" slot-scope="data">
							<b-link v-if="data.item.documentStatus === 'SUSPENDED'" @click="editForm(data.item)" class="ml-2 text-primary">
								<i class="fa fa-edit"></i>
							</b-link>
							<b-link v-if="data.item.documentStatus === 'SUSPENDED'" :key="data.item.id + 'delete'" :id="'popOverDelete'+data.item.id" @click="$refs[`popover${data.item.id}`].$emit('open')" class="ml-2 text-danger">
								<i class="fa fa-trash"></i>
							</b-link>
							<b-link v-if="data.item.documentStatus !== 'SUSPENDED'" class="ml-2 text-dark" :to="'/warehouse-management/term-of-items/view/out/' + data.item.id">
								<i class="fa fa-eye"></i>
							</b-link>
							<b-popover :key="data.item.id + 'popover'" :target="'popOverDelete'+data.item.id" placement="left" :ref="'popover'+data.item.id" class="refDeleteConfirm">
								<template slot="title">
									<b-button @click="$refs[`popover${data.item.id}`].$emit('close')" class="close" aria-label="Close" style="margin-left: 5px">
										<span class="d-inline-block" aria-hidden="true">&times;</span>
									</b-button>
									{{ $t('want_to_delete?') }}
								</template>
								<div>
									<div class="row mt-1">
										<div class="col-6">
											<b-button variant="outline-danger" size="sm" block @click="$refs[`popover${data.item.id}`].$emit('close')"> {{$t('actions.no') }}</b-button>
										</div>
										<div class="col-6">
											<b-button variant="outline-success" size="sm" block @click="deleteForm(data.item.id)">{{ $t('actions.yes') }}</b-button>
										</div>
									</div>
								</div>
							</b-popover>
						</template>
					</b-table>
				</b-tab>
				<b-tab title="Приход">
					<b-table :items="list" :fields="fields" striped hover show-empty empty-text="Информация не найдена !">
						<template slot="id" slot-scope="data">
							{{ paginate(data.index, payload.page, payload.limit) }}
						</template>
						<template slot="action" slot-scope="data">
							<b-link class="ml-2 text-dark" :to="'/warehouse-management/term-of-items/view/in/' + data.item.id">
								<i class="fa fa-eye"></i>
							</b-link>
						</template>
					</b-table>
				</b-tab>
			</b-tabs>
			<nav class="text-center mt-2">
				<pagination background :total="total" layout="prev, pager, next" :page-size="payload.limit" :current-page.sync="payload.page"/>
			</nav>
		</b-overlay>

		<!--		Create -- or -- Edit		-->
		<b-modal v-model="createOrEditModal" :title="create ? `Создать` : `Редактировать`" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl" hide-footer>
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col cols="4">
						<b-input-group size="sm" prepend="Документ №">
							<b-form-input v-model="form.regNumber" disabled/>
						</b-input-group>
						<b-input-group prepend="Датa" class="mt-3">
							<date-picker v-model="form.regDate" style="left: -14px" name="regDate" lang="ru" :placeholder="$t('incomes.create.reg-date')" valueType="format" format="DD-MM-YYYY"/>
						</b-input-group>
						<multiselect v-model="departmentId" :options="departments" track-by="id" :show-labels="false" :allow-empty="true" label="name" :placeholder="$t('incomeFilter.department')" class="multiselect-pricing mt-3"/>
						<b-input-group size="sm" prepend="Основания" class="mt-3">
							<b-form-input v-model="form.reason" type="text"/>
						</b-input-group>
						<b-input-group size="sm" prepend="Комментарии" class="mt-3">
							<b-form-input v-model="form.comment" type="text"/>
						</b-input-group>
					</b-col>
					<b-col>
						<multiselect v-model="item" :options="whItems" @search-change="getItems($event)" @select="selectedItem" track-by="id" :close-on-select="true" :internal-search="false" :searchable="true" :show-labels="false" :allow-empty="true" label="name" placeholder="Продукты">
							<template slot="singleLabel" slot-scope="props">
								<span>
									{{ props.option.barcode }} <b>/</b> {{ props.option.name ? props.option.name : props.option.itemName }} <b>/ Остаток: </b> {{ props.option.count1 }} <b>/ Цена: </b> {{ props.option.price }} <b>/ Срокгодность: </b> {{ props.option.termOfItem }} <b>/ {{ props.option.regNumber }}: </b> {{ props.option.regDate }}
								</span>
							</template>
							<template slot="option" slot-scope="option">
								<span>
									{{ option.option.barcode }} <b>/</b> {{ option.option.name ? option.option.name : option.option.itemName }} <b>/ Остаток: </b> {{ option.option.count1 }} <b>/ Цена: </b> {{ option.option.price }} <b>/ Срокгодность: </b> {{ option.option.termOfItem }} <b>/ {{ option.option.regNumber }}: </b> {{ option.option.regDate }}
								</span>
							</template>
						</multiselect>
						<b-row>
							<b-col>
								<table class="table table-hover table-striped table-bordered">
									<thead>
									<tr>
										<th class="text-center">№</th>
										<th class="text-center">{{ 'Продукт' }}</th>
										<th class="text-center">{{ 'Срок годность' }}</th>
										<th class="text-center">{{ 'Новый срок годность' }}</th>
										<th class="text-center">{{ 'Остаток' }}</th>
										<th class="text-center">{{ 'Цена' }}</th>
										<th class="text-center">{{ $t('goods.actions') }}</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(item, index) in form.whItems" :key="`item-${index}`">
										<td class="text-center pt-2">{{ index+1 }}</td>
										<td class="pt-2"><b>{{ item.barcode }} </b> {{ item.itemName }}</td>
										<td class="text-center pt-2">{{ item.termOfItem }}</td>
										<td class="text-center">
											<date-picker v-model="item.newTermOfItem" @input="form.whItems.unshift({}); form.whItems.splice(0, 1); $forceUpdate()" size="sm" lang="ru" placeholder="Новый срок годность" valueType="format" format="DD-MM-YYYY"/>
										</td>
										<td class="text-center pt-2">{{ item.count }}</td>
										<td class="text-center pt-2">{{ item.price ? item.price : item.priceUzs }}</td>
										<td class="text-center" style="width: 6%">
											<b-button @click="deleteWhItem(index, item)" size="sm" variant="danger" class="fa fa-trash"/>
										</td>
									</tr>
									</tbody>
								</table>
							</b-col>
						</b-row>
					</b-col>
				</b-row>
				<hr>
				<div class="card-header-actions">
					<b-button @click="createOrEditModal = false" variant="outline-danger" class="mr-3" size="sm">{{ $t('cancel') }}</b-button>
					<b-button @click="save('SUSPENDED')" variant="warning" class="mr-3" size="sm">{{ $t('save') }}</b-button>
					<b-button v-if="$can('pricing', 'manager')" @click="save('READY')" variant="success" size="sm">{{ $t('save-finish') }}</b-button>
				</div>
			</b-overlay>
		</b-modal>

		<!--		Date		-->
		<b-modal v-model="dateConfirmModal" @ok="confirmDateDoc(true)" @cancel="confirmDateDoc(false)" title="Подтвердите" size="sm" button-size="sm" ok-variant="success" ok-title="Да" cancel-variant="danger" cancel-title="Нет" centered no-close-on-backdrop no-close-on-esc>
			<p>Вы не сохраняете Накладной с сегодняшней датой. Если вы уверены то нажмите да, в противном случи оно сохранится с сегодняшней датой !</p>
		</b-modal>
	</b-card>
</template>

<script>
import {Pagination} from 'element-ui';
import { BOverlay } from 'bootstrapVue2';
import TermOfItemService from "./termOfItemService";
import Multiselect from 'vue-multiselect';
import UsersService from "../../../services/users.sevice";
import WhDocument from "../../../services/wh-document.service";
import {TokenService} from "../../../services/storage.service";
import PromoService from "../../../services/promo.service";

export default {
	name: "index",
	components: {Pagination, BOverlay, Multiselect},
	data() {
		return {
			tab: 0,
			payload: {
				page: 1,
				limit: 20
			},
			list: [],
			total: 0,
			loading: false,
			fields: [
				{key: 'action', label: 'Действие', class: 'text-center'},
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'regNumber', label: 'Документ №', class: 'text-center'},
				{key: 'regDate', label: 'Дата', class: 'text-center'},
				{key: 'toDepartmentName', label: 'Отдел', class: 'text-center'},
				{key: 'reason', label: 'Основания'},
				{key: 'comment', label: 'Комментарии'},
				{key: 'documentStatus', label: 'Статус', class: 'text-center'},
				{key: 'docCreatedBy', label: 'Создатель', class: 'text-center'},
				{key: 'docCreatedDate', label: 'Дата создания', class: 'text-center'}
			],
			fields1: [
				{key: 'action', label: 'Действие', class: 'text-center'},
				{key: 'id', label: '№', class: 'text-center'},
				{key: 'regNumber', label: 'Документ №', class: 'text-center'},
				{key: 'regDate', label: 'Дата', class: 'text-center'},
				{key: 'fromDepartmentName', label: 'Отдел', class: 'text-center'},
				{key: 'reason', label: 'Основания'},
				{key: 'comment', label: 'Комментарии'},
				{key: 'documentStatus', label: 'Статус', class: 'text-center'},
				{key: 'docCreatedBy', label: 'Создатель', class: 'text-center'},
				{key: 'docCreatedDate', label: 'Дата создания', class: 'text-center'}
			],
			createOrEditModal: false,
			create: true,
			form: {},
			departments: [],
			whItems: [],
			item: null,
			departmentId: null,
			depCurrencyName: TokenService.getDepCurrencyName(),
			dateConfirmModal: false
		}
	},
	watch: {
		'departmentId': {
			handler(d) {
				if (d) this.getItems(null);
			}
		},
		'tab': {
			handler(t) {
				this.getList(1);
			}
		},
		'payload.page': {
			handler(p) {
				this.getList();
			}
		}
	},
	methods: {
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getTodayDate() {
			let today = new Date();
			var dd = String(today.getDate()).padStart(2, '0');
			var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
			var yyyy = today.getFullYear();
			today = dd + '-' + mm + '-' + yyyy;
			return String(today);
		},
		getList(page) {
			this.loading = true
			if (page)
				this.payload.page = page
			if (this.tab === 1) {
				TermOfItemService.getListIn(this.payload).then(res => {
					this.list = res.data.items
					this.total = res.data.total
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				TermOfItemService.getListOut(this.payload).then(res => {
					this.list = res.data.items
					this.total = res.data.total
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			}
		},
		getItems($event = null) {
			if ($event === '') {
				$event = null
			}
			if (this.departmentId) {
				this.loading = true
				let data = {
					depId: this.departmentId.id,
					keyword: $event
				}
				WhDocument.getItemsForDepBySaleTypeRetailOffTermOfItem(data).then(res => {
					this.whItems = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.$vs.notify({
					title: 'Сначала выберите подразделение!',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				})
			}
		},
		getDepartments(id) {
			this.loading = true
			UsersService.getPermittedDepartments().then(res => {
				this.departments = res.data.permittedDepartments
				if (id) {
					this.departments.forEach(d => {
						if (d.id === id)
							this.departmentId = d
					})
				}
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		selectedItem(item) {
			let whItem = {
				barcode: item.barcode,
				count: item.count1,
				currencyId: null,
				documentId: this.form ? this.form.id : null,
				fromDepartmentId: this.departmentId ? this.departmentId.id : null,
				id: null,
				incomeDocId: item.incomeDocId ? item.incomeDocId : null,
				incomingPriceUsd: null,
				incomingPriceUzs: null,
				inventoryNum: item.count1,
				itemId: item.id,
				itemName: item.name,
				multiBarcodes: item.multiBarcodes,
				price: item.price,
				priceUsd: null,
				priceUzs: item.price,
				priceWholesale: 0,
				providerId: null,
				providerName: null,
				realBalance: item.count1,
				regNumber: item.regNumber,
				regDate: item.regDate,
				sectorId: null,
				termOfItem: item.termOfItem,
				newTermOfItem: '',
				toDepartmentId: null,
				unitName: "dona",
				wrapped: false
			}
			if (this.form.whItems) {
				if (this.form.whItems.length > 0) {
					let boolean = false,
						index = null,
						temp = {}
					this.form.whItems.forEach((tmp, i) => {
						if (tmp.itemId == whItem.itemId) {
							boolean = true
							index = i
							temp = tmp
						}
					})
					if (boolean) {
						this.form.whItems.splice(index, 1)
						this.form.whItems.unshift(temp)
					} else {
						this.form.whItems.unshift(whItem)
					}
				} else {
					this.form.whItems.unshift(whItem)
				}
			} else {
				this.form.whItems = []
				this.form.whItems.unshift(whItem)
			}
			this.item = null
			this.$forceUpdate();
		},
		deleteWhItem(index, item) {
			this.item = null
			item.newTermOfItem = null
			this.form.whItems.splice(index, 1)
			this.$forceUpdate();
		},
		createForm() {
			this.loading = true
			let data = {action: 'SPISAT_OUT', documentType: 'PROTOKOL'}
			TermOfItemService.createDraft(data).then(res => {
				this.getDepartments();
				this.loading = false
				this.form = res.data
				this.departmentId = null
				this.item = null
				this.whItems = []
				this.create = true
				this.createOrEditModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		editForm(doc) {
			this.loading = true
			TermOfItemService.getById(doc.id).then(res => {
				this.getDepartments(res.data.fromDepartmentId);
				this.loading = false
				this.form = res.data
				this.item = null
				this.create = false
				this.createOrEditModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		deleteForm(id) {
			this.loading = true
			TermOfItemService.deleteDoc(id).then(res => {
				this.loading = false
				this.$refs[`popover${id}`].$emit('close');
				this.getList();
				this.$vs.notify({
					title: 'Успешно удалено!',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		save(status) {
			if (this.departmentId && this.form.regDate && this.form.regDate !== '' && this.form.whItems && this.form.whItems.length > 0) {
				this.form.documentStatus = status
				this.form.fromDepartmentId = this.departmentId.id
				if (status === 'READY') {
					if (this.form.regDate !== this.getTodayDate()) {
						this.dateConfirmModal = true
						return false;
					} else {
						this.saveAndFinish();
					}
				} else {
					this.saveAndFinish();
				}
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля!',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			}
		},
		saveAndFinish() {
			this.loading = true
			TermOfItemService.save(this.form).then(res => {
				this.loading = false
				this.createOrEditModal = false
				this.dateConfirmModal = false
				this.getList();
				this.$vs.notify({
					title: 'Успешно сохранено!',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		confirmDateDoc(tmp) {
			if (!tmp) this.form.regDate = this.getTodayDate();
			this.saveAndFinish();
		}
	},
	created() {
		this.getList();
	}
}
</script>

<style scoped>

</style>
